import axios from 'axios'
import { BoltApiResponseBody } from 'types/bolt-api/request'
import { EnergyOverviewCommunity, GetYearOverviewMetricsResponse } from 'lib/metrics/types'

/**
 * Get the community year overview metrics
 * @returns {Promise<EnergyOverviewCommunity | null>}
 */
const getCommunityMetrics = async (): Promise<EnergyOverviewCommunity | null> => {
  try {
    // Not passing through /pages/api/... because it is getting fetched inside getStaticProps.
    // /api routes are not accessible during build time.
    const {
      data: { success, data }
    } = await axios.get<BoltApiResponseBody<GetYearOverviewMetricsResponse>>(`${process.env.API_URL}/metrics/year-overview`, {
      headers: {
        Authorization: `Basic ${process.env.API_TOKEN}`
      }
    })

    return success && data?.yearOverviewMetrics ? data.yearOverviewMetrics.community || null : null
  } catch (err) {
    return null
  }
}

export default getCommunityMetrics
